export const outdoorsynatural = {
  name: 'Outdoorsy & Natural',
  color: [0.2823529411764706, 0.4196078431372549, 0, 1],
  bg: [0.1803921568627451, 0.27450980392156865, 0, 1],
  grid1: [0.6352941176470588, 0.7725490196078432, 0.13725490196078433, 1],
  grid2: [0.49019607843137253, 0.26666666666666666, 0.15294117647058825, 1],
}
